// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.prototype.deBug = $_____DEBUG_____$;
import router from './router'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies);
import Vconsole from 'vconsole'

if ($_____VConsole_____$) {
    let vConsole = new Vconsole()
    Vue.use(vConsole);
}

import infiniteScroll from 'vue-infinite-scroll'

Vue.use(infiniteScroll);

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(MintUI);

import Loading from './module/loading'

Vue.use(Loading);

import canvasDraw from './module/canvasDraw'

Vue.use(canvasDraw);

import canvasRadar from './module/canvasRadar'

Vue.use(canvasRadar);

import VueResource from 'vue-resource'

Vue.use(VueResource);

Vue.prototype.countDown = function (time) {
    let That = this;
    if (That.waitCode == 0) {
        time.removeAttr("disabled");
        time.text("重新发送");
        That.waitCode = 60;
    } else {
        time.attr("disabled", "");
        time.text("重新发送(" + That.waitCode + ")");
        That.waitCode--;
        setTimeout(function () {
            That.countDown(time);
        }, 1000);
    }
},

Vue.prototype.getImgSrc = function (imgSrc) {
    if (imgSrc != '' && imgSrc != undefined && imgSrc != null) {
        if (imgSrc.indexOf('http') === -1) {
            return this.Root + imgSrc;
        }
    }
    return imgSrc;
};

Vue.prototype.goWebView = function (goUrl, token = false) {
    this.$router.push({
        path: '/webView/webView',
        query: {
            goUrl: goUrl
        }
    });
}

Vue.prototype.goWebView2 = function (goUrl, token = false) {
    this.$router.push({
        path: '/webView/webView2',
        query: {
            goUrl: goUrl
        }
    });
}

import local from "./controller/continue/local";

Vue.prototype.pageBack = function (params = {}, exclude = []) {
    let That = this;
    let url = (new local()).get(That.$route.meta.title + 'PageBackUrl');
    if (url == null) {
        if (That.$route.meta.default) {
            url = That.$route.meta.default;
        } else {
            That.$router.go(-1);
        }
    }

    if (exclude != '') {
        let urlFormat = '';
        for (var i = 0; i < exclude.length; i++) {
            if (url.indexOf(exclude[i] + '=') !== -1) {
                let tempUrl = '';
                let temp1 = url.split(exclude[i] + '=');
                tempUrl += temp1[0];
                if (temp1[1].indexOf('&') !== -1) {
                    let temp2 = temp1[1].split('&');
                    for (var i = 0; i < temp2.length; i++) {
                        if (i != 0) {
                            if (i != 1) {
                                tempUrl += '&';
                            }
                            tempUrl += temp2[i];
                        }
                    }
                }
                url = tempUrl;
            }
        }
    }


    if (params != '') {
        let urlFormat = '';
        for (var k in params) {
            if (url.indexOf(k + '=') !== -1) {
                let tempUrl = '';
                let temp1 = url.split(k + '=');
                tempUrl += temp1[0];
                if (temp1[1].indexOf('&') !== -1) {
                    let temp2 = temp1[1].split('&');
                    for (var i = 0; i < temp2.length; i++) {
                        if (i != 0) {

                            if (i != 1) {
                                tempUrl += '&';
                            }
                            tempUrl += temp2[i];
                        }
                    }
                }
                url = tempUrl;
            }
            urlFormat += k + '=' + params[k] + '&';
        }
        urlFormat = urlFormat.substring(0, urlFormat.length - 1);

        if (url.indexOf('?') !== -1) {
            url += '&' + urlFormat
        } else {
            url += '?' + urlFormat
        }
    }

    (new local()).remove(That.$route.meta.title + 'PageBackUrl')
    That.$router.push({
        path: url,
    });
}


Vue.prototype.rebuildParams = function (url = '', params = {}, exclude = []) {
    let urlArr = url.split('?');
    let origin = urlArr[0];
    let paramsArray = [];
    let param = '';
    if (urlArr.length === 2) {
        let param = urlArr[1];
        let paramsArr = param.split('&');
        for (let n = 0; n < paramsArr.length; n++) {
            let info = false;
            for (let i = 0; i < exclude.length; i++) {
                if (paramsArr[n].indexOf(exclude[i] + '=') !== -1) {
                    info = true;
                    break;
                }
            }
            if(!info){
                paramsArray.push(paramsArr[n])
            }
        }
    }
    for(let item in params){
        paramsArray.push(item+'='+params[item])
    }
    for(let item of paramsArray){
        param += item + '&';
    }
    param = param.substring(0, param.lastIndexOf('&'));
    return param === '' ? origin : origin + '?' + param;
}


Vue.prototype.go = function (url, query = {}) {
    let params = {}
    params['path'] = url;
    this.$router.push({
        path: url,
        query: query
    })
}

Vue.prototype.isWeChat = function () {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
};

Vue.prototype.query = function (name){
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};
import VueWechatTitle from 'vue-wechat-title'

Vue.use(VueWechatTitle)

Vue.prototype.loading = {
    close() {
        $('#loading').addClass('layui-anim-fadeout');
        $('#loading').removeClass('layui-anim-fadein');
        setTimeout(function () {
            $('#loading').hide();
            $('#loading').css({
                'background': 'rgba(255,255,255,1)'
            })
        }, 300);
    },
    ready() {
        $('#loading').show();
        $('#loading').addClass('layui-anim-fadein');
        $('#loading').removeClass('layui-anim-fadeout')
    }
};


Vue.prototype.wechatSign = function (redirect_uri) {
    let That = this;
    if (this.deBug) {
        redirect_uri = 'http://wanyin.heimeiai.com/api/rollBack?url=' + encodeURIComponent(redirect_uri)
        redirect_uri = encodeURIComponent(redirect_uri);
    } else {
        redirect_uri = encodeURIComponent(redirect_uri);
    }
    location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + That.base.weChart.appid + '&redirect_uri=' + redirect_uri + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect');
};

import './assets/api/api'
import './listen/request'

Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
    mounted(){
      document.dispatchEvent(new Event('render-event'))
    }
});



// WEBPACK FOOTER //
// ./src/main.js